import { useTranslation } from 'react-i18next';

export default function PhilosophySection() {
  const { t } = useTranslation();

  return (
    <section className="py-24 md:py-32 px-4 sm:px-6 lg:px-8 relative bg-navy overflow-hidden">
      {/* Background Image Overlay with parallax-like effect */}
      <div className="absolute inset-0 opacity-40">
        <img 
          src="/images/campus/entrance.jpg" 
          alt="Philosophy Background" 
          className="w-full h-full object-cover scale-110"
          loading="lazy"
        />
      </div>
      
      {/* Gradient for depth and contrast */}
      <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/40 to-transparent"></div>
      
      {/* Content Box - High impact center card */}
      <div className="max-w-4xl mx-auto relative z-10 bg-white p-8 md:p-24 shadow-2xl text-center rounded-sm animate-in fade-in slide-in-from-bottom-12 duration-1000">
        <div className="w-20 md:w-24 h-1 bg-gold mx-auto mb-8 md:mb-10"></div>
        
        <h2 className="text-navy text-3xl md:text-5xl font-black mb-8 md:mb-10 uppercase tracking-tight italic font-playfair leading-tight">
          {t('about_philosophy_quote', "Né à l'Image de Dieu, vous êtes CO-CRÉATEUR")}
        </h2>
        
        <div className="space-y-6 md:space-y-8 text-lg md:text-xl leading-relaxed text-gray-700">
          <p className="font-bold text-navy text-xl md:text-2xl uppercase tracking-wider">
            {t('about_vision_title', 'Notre Vision & Valeurs')}
          </p>
          <p className="font-light">
            {t('about_vision_text', "Devenir une université d'excellence mondialement reconnue, pionnière en entrepreneuriat, innovation et impact sociétal.")}
          </p>
          
          {/* Pillars List - 4 Core values of ESTAD */}
          <div className="grid grid-cols-2 md:flex md:flex-wrap justify-center gap-6 md:gap-12 mt-10 md:mt-12 pt-10 border-t border-gray-100">
            {['foi', 'rationalité', 'courage', 'stratégie'].map((pillarKey) => (
              <div key={pillarKey} className="flex flex-col items-center">
                <span className="text-gold text-base md:text-lg font-black uppercase tracking-widest border-b-2 border-transparent hover:border-gold transition-all cursor-default">
                  {t(`pillar_${pillarKey}`)}
                </span>
              </div>
            ))}
          </div>
        </div>
        
        <p className="mt-12 text-sm text-gray-400 italic font-medium">
          {t('campus_values_quote', '"Ne rien faire pour nuire, tout faire pour construire la paix."')}
        </p>
      </div>
    </section>
  );
}
